import { AutogenLayoutTransmissionControlModal } from "./autogen/AutogenLayoutTransmissionControlModal";

export class TransmissionControlModal extends AutogenLayoutTransmissionControlModal {
    
}